import { render } from "./DBLinkedDataForm.vue?vue&type=template&id=2bd68aee&ts=true"
import script from "./DBLinkedDataForm.vue?vue&type=script&lang=ts"
export * from "./DBLinkedDataForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__